export default __webpack_public_path__ + "static/media/steveJobs.a4392073.jpg";